import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';

import { Announcement } from '@utilities';

const KeyFindings = ({ data }) => {
  return (
    <Announcement
      hasClose
      header={'Key Findings'}
      text={<ReactMarkdown>{data?.output}</ReactMarkdown>}
      variant="info"
    />
  );
};

KeyFindings.propTypes = {
  data: PropTypes.object,
};

export default KeyFindings;
